import EFPicture from 'elem/compCommon/EFPicture';
import { useCountDown } from 'ahooks';
import { useEffect, useState } from 'react';
import EfLink from 'elem/ui/ef-link';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A({ systemTime }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const LINK = 'https://www.amazon.co.jp/stores/page/892CF46C-5300-434A-ACF8-3154B4053273?ingress=0&visitId=f4459875-d3ea-4cd5-b79a-ab0a6b986de2';
    const leftTime = new Date('2024-09-04 23:00:00 GMT+8').getTime() - systemTime;
    const [_, formattedRes] = useCountDown({ leftTime });
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <div className={`amazon-sale-A ${css['amazon-sale-A']}`}>
            <EFPicture
                src="https://websiteoss.ecoflow.com/upload/image/1724048484179/amazon_sale_kv_pc.png"
                srcMobile="https://websiteoss.ecoflow.com/upload/image/1724048483461/amazon_sale_kv_h5.png"
                alt={t('sectionA_title')}
            />
            <EFPicture
                className="icon"
                src="https://websiteoss.ecoflow.com/upload/image/1724317213122/pc.png"
                srcPad="https://websiteoss.ecoflow.com/upload/image/1724317212957/h5.png"
                srcMobile="https://websiteoss.ecoflow.com/upload/image/1724317212957/h5.png"
                alt={t('sectionA_title')}
            />
            <div className="text-content">
                <p className="subtitle">{t('sectionA_subtitle')}</p>
                <p className="title">{t('sectionA_title')}</p>
                <p className="desc">{t('sectionA_desc')}</p>
            </div>
            <div className="time-content">
                <p className="time-tips">{t('time_tips')}</p>
                {isClient && (
                    <div className="countdown">
                        <div className="date days">
                            <p className="num">{String(formattedRes.days).padStart(2, '0')}</p>
                            <p className="unit">{t('time_1')}</p>
                        </div>
                        ：
                        <div className="date hours">
                            <p className="num">{String(formattedRes.hours).padStart(2, '0')}</p>
                            <p className="unit">{t('time_2')}</p>
                        </div>
                        ：
                        <div className="date minutes">
                            <p className="num">{String(formattedRes.minutes).padStart(2, '0')}</p>
                            <p className="unit">{t('time_3')}</p>
                        </div>
                        ：
                        <div className="date seconds">
                            <p className="num">{String(formattedRes.seconds).padStart(2, '0')}</p>
                            <p className="unit">{t('time_4')}</p>
                        </div>
                    </div>
                )}
            </div>
            <EfLink
                href={LINK}
                className="banner-btn"
                dataLayer={[
                    {
                        event: 'uaEvent',
                        event_name: 'buy_on_amazon',
                        product_name: 'None',
                        button_name: t('sectionA_btn'),
                        list_name: t('sectionA_title'),
                    },
                ]}
            >
                {t('sectionA_btn')}
            </EfLink>
        </div>
    );
}
